import Button from "../atoms/Button";

interface PropsType {
    title: string;
    ctaText: string;
    ctaUrl?: string;
}

const ManageClubTitle = ({ title, ctaText, ctaUrl }: PropsType) => (
    <div className="manage-club-title__container">
        <div className="manage-club-title__container__height-fix">
            <h2 className="manage-club-title__heading">{title}</h2>
        </div>
        <div className="manage-club-title__container__height-fix">
            <Button to={ctaUrl} styles={["green"]} inline={true}>
                {ctaText}
            </Button>
        </div>
    </div>
);

export default ManageClubTitle;
